// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fi-date-picker {
  display: inline-block;
  max-width: 100%;
}
.fi-date-picker.popup-mode {
  display: block;
  position: absolute;
}
.fi-date-picker.popup-mode > .input-group {
  width: 0px;
  height: 0px;
}
.fi-date-picker.popup-mode .mat-datepicker-toggle {
  display: none;
}
.fi-date-picker .mat-mdc-form-field .mat-mdc-form-field-icon-suffix {
  margin-right: 10px;
}
.fi-date-picker > .input-group {
  display: inline-block;
  width: 100%;
  /*
  [ngbDatepicker] {
    width: 100px;
  }
  */
}
.fi-date-picker > .input-group > .input-group-btn {
  display: inline-block;
}
.fi-date-picker .dropdown-menu.d-inline-block {
  display: inline-block !important;
}`, "",{"version":3,"sources":["webpack://./Source/app/shared/fi-date-picker/date-picker.component.scss"],"names":[],"mappings":"AAAA;EAeI,qBAAA;EACA,eAAA;AAbJ;AAFI;EACI,cAAA;EACA,kBAAA;AAIR;AAFQ;EACI,UAAA;EACA,WAAA;AAIZ;AADQ;EACI,aAAA;AAGZ;AAII;EACI,kBAAA;AAFR;AAKI;EACI,qBAAA;EACA,WAAA;EAEA;;;;GAAA;AAAR;AAMQ;EACI,qBAAA;AAJZ;AAQI;EACI,gCAAA;AANR","sourcesContent":[".fi-date-picker {\r\n    &.popup-mode {\r\n        display: block;\r\n        position: absolute;\r\n\r\n        > .input-group {\r\n            width: 0px;\r\n            height: 0px;\r\n        }\r\n\r\n        .mat-datepicker-toggle {\r\n            display: none;\r\n        }\r\n    }\r\n\r\n    display: inline-block;\r\n    max-width: 100%;\r\n\r\n    .mat-mdc-form-field .mat-mdc-form-field-icon-suffix {\r\n        margin-right: 10px;\r\n    }\r\n\r\n    > .input-group {\r\n        display: inline-block;\r\n        width: 100%;\r\n\r\n        /*\r\n    [ngbDatepicker] {\r\n      width: 100px;\r\n    }\r\n    */\r\n\r\n        > .input-group-btn {\r\n            display: inline-block;\r\n        }\r\n    }\r\n\r\n    .dropdown-menu.d-inline-block {\r\n        display: inline-block !important;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
